import { useParams } from "react-router-dom";
import SiteDetail from "@/pages/detail/components/SiteDetail";

export default function DetailPage() {
  const { siteId = "" } = useParams();
  return <SiteDetail siteId={siteId} />;
}